import {
  RepeatedItemContainerProps,
  isGroupItem
} from '@healthnz-prm/fhir-engine-renderer/types'
import { HugeiconsIcon } from '@hugeicons/react'
import { Cancel01Icon } from '@hugeicons/core-free-icons'

import { Show } from '@/components/show'
import { Separator } from '@/components/ui/separator'
import { Button } from '@/components/ui/button'

interface RemoveButtonProps {
  disabled?: boolean
  onPress: () => void
}

function RemoveButton({ disabled, onPress }: RemoveButtonProps) {
  return (
    <Button
      type='button'
      variant='ghost'
      size='icon-sm'
      aria-label='remove answer'
      disabled={disabled}
      onClick={onPress}
    >
      <HugeiconsIcon icon={Cancel01Icon} />
    </Button>
  )
}

export default function RepeatedItemContainer({
  canRemove,
  count,
  item,
  onRemove,
  RenderItem
}: RepeatedItemContainerProps<any>) {
  // we've chosen not to wrap Group Items in <Card>s inside the <GroupInput> to allow for
  // nesting the next button inside the final Group's <Card> in the <PageLayout>
  // this requires us to wrap Group Items everywhere else they're used
  if (isGroupItem(item)) {
    return (
      <>
        <Show when={item.text}>
          <div className='flex items-center justify-between'>
            <h4 className='text-base font-semibold'>{item.text}</h4>
            <RemoveButton
              disabled={!canRemove || count <= 1}
              onPress={onRemove}
            />
          </div>
          <div className='mb-4 mt-2'>
            <Separator />
          </div>
        </Show>
        <RenderItem item={item} hideLabel hideHelperText />
      </>
    )
  }

  return (
    <div key={item.linkId} className='flex w-full items-center gap-1'>
      <div className='min-w-0 flex-1'>
        <RenderItem item={item} hideLabel hideHelperText />
      </div>
      <RemoveButton disabled={!canRemove || count <= 1} onPress={onRemove} />
    </div>
  )
}
